<template>
    <div>
        <form v-on:submit.prevent="updateOngkir">
            <div class="row">
                <div class="col-md-12">
                    <input name="hide" class="checkbox" type="checkbox" id="check-3" v-model="form.enable_ai_ongkir">
                    <label for="check-3">
                        <span class="checkbox-text" style="margin-left: 5px;">Aktifkan AI Cek Ongkir</span>
                    </label>
                    <br>
                    <label>Berat Produk (gram)</label>
                    <input type="number" class="form-control" v-model="form.product_weight" required />
                    <br />
                    <label>Asal Pengiriman</label>
                    <multiselect v-model="selectedOrigin" tag-placeholder="Pilih Asal Pengiriman"
                        placeholder="Ketik min. 3 huruf (kecamatan/kota)..." label="name" track-by="id"
                        :options="locations" @search-change="searchOrigin" :loading="isLoadingOrigin"
                        :internal-search="false" :clear-on-select="false" :preserve-search="true">
                    </multiselect>
                    <small v-if="selectedOrigin" class="text-muted">ID: {{ selectedOrigin.id }}</small>

                    <br>
                    <label>Kurir</label>
                    <multiselect v-model="selectedCourier" tag-placeholder="Pilih Kurir" placeholder="Pilih Kurir"
                        label="name" track-by="id" :options="courier" :multiple="true">
                    </multiselect>
                </div>
            </div>
            <br>
            <div class="button-group d-flex pt-25">
                <button type="submit"
                    class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
                    Simpan
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'

export default {
    props: ['id', 'form'],
    components: {
        Multiselect
    },
    data() {
        return {
            locations: [],
            selectedOrigin: null,
            isLoadingOrigin: false,
            searchTimer: null,
            selectedCourier: [],
            courier: [
                { id: "jne", name: "JNE" },
                { id: "sicepat", name: "Si Cepat" },
                { id: "ide", name: "ID Express" },
                { id: "sap", name: "SAP" },
                { id: "jnt", name: "J&T" },
                { id: "ninja", name: "Ninja" },
                { id: "tiki", name: "TIKI" },
                { id: "lion", name: "Lion Parcel" },
                { id: "anteraja", name: "Anteraja" },
                { id: "pos", name: "POS Indonesia" },
                { id: "ncs", name: "NCS" },
                { id: "rex", name: "REX" },
                { id: "rpx", name: "RPX" },
                { id: "sentral", name: "Sentral Cargo" },
                { id: "star", name: "Star Cargo" },
                { id: "wahana", name: "Wahana" },
            ],
        };
    },
    mounted() {
        this.restoreOriginSelection()
        if (this.form.courier != null && this.form.courier !== '') {
            const ids = this.form.courier.split(':')
            this.selectedCourier = this.courier.filter(x => ids.includes(x.id))
        }
    },
    methods: {
        restoreOriginSelection() {
            const originId = parseInt(this.form.origin_id, 10) || 0
            const label = (this.form.origin_label || '').trim()
            if (originId <= 0) {
                this.selectedOrigin = null
                return
            }
            const name = label || `Origin #${originId}`
            this.selectedOrigin = { id: originId, name }
            if (!this.locations.find(x => x.id === originId)) {
                this.locations = [this.selectedOrigin, ...this.locations]
            }
        },
        searchOrigin(query) {
            clearTimeout(this.searchTimer)
            const q = (query || '').trim()
            if (q.length < 3) {
                if (this.selectedOrigin && !this.locations.find(x => x.id === this.selectedOrigin.id)) {
                    this.locations = [this.selectedOrigin]
                }
                return
            }
            this.searchTimer = setTimeout(() => this.fetchDestinations(q), 300)
        },
        async fetchDestinations(q) {
            this.isLoadingOrigin = true
            try {
                const res = await axios.get('chat-gpt/shipping/destinations', {
                    params: { q, chatgpt_id: this.id }
                })
                const list = (res.data?.data?.destinations || []).map(d => {
                    const id = d.id ?? d.ID ?? d.destination_id
                    const name =
                        d.label ||
                        d.Label ||
                        d.name ||
                        (id != null && id !== '' ? String(id) : '')
                    return { id, name }
                }).filter(d => d.id != null && d.id !== '' && d.name)
                if (this.selectedOrigin && !list.find(x => x.id === this.selectedOrigin.id)) {
                    list.unshift(this.selectedOrigin)
                }
                this.locations = list
            } catch (err) {
                console.error('search origin failed', err)
            } finally {
                this.isLoadingOrigin = false
            }
        },
        async updateOngkir() {
            try {
                if (!this.selectedOrigin || !this.selectedOrigin.id) {
                    this.$toast.error('Pilih asal pengiriman terlebih dahulu')
                    return
                }
                const request = {
                    id: this.id,
                    enable_ai_ongkir: this.form.enable_ai_ongkir ? 1 : 0,
                    product_weight: parseInt(this.form.product_weight, 10) || 0,
                    origin_id: parseInt(this.selectedOrigin.id, 10),
                    origin_label: this.selectedOrigin.name,
                    courier: this.selectedCourier.map(x => x.id).join(':')
                }

                const response = await this.$store.dispatch('chatgpt_update_ongkir', request)
                const saved = response.data?.data?.chatgpt
                if (saved) {
                    this.form.origin_id = saved.origin_id
                    this.form.origin_label = saved.origin_label
                    this.form.courier = saved.courier
                    this.form.product_weight = saved.product_weight
                    this.form.enable_ai_ongkir = saved.enable_ai_ongkir
                }
                this.restoreOriginSelection()
                this.$toast.success(response.data.message)
            } catch (err) {
                const errorMessage = err.response?.data?.message || 'Something went wrong'
                this.$toast.error(errorMessage)
            }
        }
    },
};
</script>
